import { DamageTypeCategory } from './types'

export const aerospaceDamageCategories: DamageTypeCategory[] = [
  {
    id: 'corrosion',
    label: 'Corrosion',
    types: [
      { id: 'general-surface-rust', label: 'General / Surface Rust' },
      { id: 'pitting', label: 'Pitting' },
      { id: 'exfoliation', label: 'Exfoliation' },
    ],
  },
  {
    id: 'structural',
    label: 'Structural',
    types: [
      { id: 'crack', label: 'Crack' },
      { id: 'dent', label: 'Dent' },
      { id: 'puncture', label: 'Puncture' },
      { id: 'delamination', label: 'Delamination' },
      { id: 'debonding', label: 'Debonding' },
      { id: 'buckling', label: 'Buckling' },
    ],
  },
  {
    id: 'other',
    label: 'Other',
    types: [
      { id: 'fluid-leak', label: 'Fluid Leak' },
      { id: 'lightning-strike', label: 'Lightning Strike' },
      { id: 'paint-defect', label: 'Paint Defect' },
    ],
  },
]

export const getAllAerospaceDamageTypes = () => {
  return aerospaceDamageCategories.flatMap((c) => c.types)
}
